import URI from "urijs";
import {ajaxAuthed, API_BASE, RESULT_LIMIT} from "./common";
import {BID, DAILYLOG, MEETINGMINUTES, PROJECT, PUNCHLIST, RFI, SUBMITTAL, TASK} from "./index";
import {APIError} from "../common/errors";

export function getFiles$({type, id, subId, offset}) {
  let url;
  let query = {
    limit: RESULT_LIMIT,
    offset
  };
  switch (type) {
    case PROJECT:
      if (!id) throw new APIError("No id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'files');
      break;
    case BID:
      if (!id) throw new APIError("No id specified");
      url = URI.joinPaths(API_BASE, 'bids', id, 'files');
      break;
    case RFI:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'project-rfis', subId, 'files');
      break;
    case SUBMITTAL:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'submittals', subId, 'files');
      break;
    case TASK:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'tasks', subId, 'files');
      break;
    case PUNCHLIST:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'punches', subId, 'files');
      break;
    case DAILYLOG:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'daily-logs', subId, 'files');
      break;
    case MEETINGMINUTES:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'meeting-minutes', subId, 'files');
      break;
    default:
      throw new APIError('not implemented');
  }
  url = url.query(URI.buildQuery(query));
  return ajaxAuthed({url: url.toString()}, type);
}

export function getFileLink$({type, id, subId, fileId}) {
  let url;
  let query = {};
  switch (type) {
    case PROJECT:
      if (!id) throw new APIError("No id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'files', fileId);
      break;
    case BID:
      if (!id) throw new APIError("No id specified");
      url = URI.joinPaths(API_BASE, 'bids', id, 'files', fileId);
      break;
    case RFI:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'project-rfis', subId, 'files', fileId);
      break;
    case SUBMITTAL:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'submittals', subId, 'files', fileId);
      break;
    case TASK:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'tasks', subId, 'files', fileId);
      break;
    case PUNCHLIST:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'punches', subId, 'files', fileId);
      break;
    case DAILYLOG:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'daily-logs', subId, 'files', fileId);
      break;
    case MEETINGMINUTES:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'meeting-minutes', subId, 'files', fileId);
      break;
    default:
      throw new APIError('not implemented');
  }
  url = url.query(URI.buildQuery(query));
  return ajaxAuthed({url: url.toString()}, type);
}

export function getFileArchiveLink$({type, id, subId}) {
  let url;
  let query = {};
  switch (type) {
    case PROJECT:
      if (!id) throw new APIError("No id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'files', 'archive');
      break;
    case BID:
      if (!id) throw new APIError("No id specified");
      url = URI.joinPaths(API_BASE, 'bids', id, 'files', 'archive');
      break;
    case RFI:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'project-rfis', subId, 'files', 'archive');
      break;
    case SUBMITTAL:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'submittals', subId, 'files', 'archive');
      break;
    case TASK:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'tasks', subId, 'files', 'archive');
      break;
    case PUNCHLIST:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'punches', subId, 'files', 'archive');
      break;
    case DAILYLOG:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'daily-logs', subId, 'files', 'archive');
      break;
    case MEETINGMINUTES:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'meeting-minutes', subId, 'files', 'archive');
      break;
    default:
      throw new APIError('not implemented');
  }
  url = url.query(URI.buildQuery(query));
  return ajaxAuthed({url: url.toString()}, type);
}

export function postFile$({type, id, subId, metadata, file}) {
  let url;
  let query = {};
  switch (type) {
    case PROJECT:
      if (!id) throw new APIError("No id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'files');
      break;
    case BID:
      if (!id) throw new APIError("No id specified");
      url = URI.joinPaths(API_BASE, 'bids', id, 'files');
      break;
    case RFI:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'project-rfis', subId, 'files');
      break;
    case SUBMITTAL:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'submittals', subId, 'files');
      break;
    case TASK:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'tasks', subId, 'files');
      break;
    case PUNCHLIST:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'punches', subId, 'files');
      break;
    case DAILYLOG:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'daily-logs', subId, 'files');
      break;
    case MEETINGMINUTES:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'meeting-minutes', subId, 'files');
      break;
    default:
      throw new APIError('not implemented');
  }
  url = url.query(URI.buildQuery(query));
  let formData = new FormData();
  formData.append('metadata', JSON.stringify(metadata));
  if (file) {
    formData.append('content', file);
  }
  return ajaxAuthed({url: url.toString(), method: 'POST', body: formData}, type);
}

export function deleteFile$({type, id, subId, fileId}) {
  let url;
  let query = {};
  switch (type) {
    case PROJECT:
      if (!id) throw new APIError("No id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'files', fileId);
      break;
    case BID:
      if (!id) throw new APIError("No id specified");
      url = URI.joinPaths(API_BASE, 'bids', id, 'files', fileId);
      break;
    case RFI:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'project-rfis', subId, 'files', fileId);
      break;
    case SUBMITTAL:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'submittals', subId, 'files', fileId);
      break;
    case TASK:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'tasks', subId, 'files', fileId);
      break;
    case PUNCHLIST:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'punches', subId, 'files', fileId);
      break;
    case DAILYLOG:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'daily-logs', subId, 'files', fileId);
      break;
    case MEETINGMINUTES:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'meeting-minutes', subId, 'files', fileId);
      break;
    default:
      throw new APIError('not implemented');
  }
  url = url.query(URI.buildQuery(query));
  return ajaxAuthed({url: url.toString(), method: 'DELETE'}, type);
}

/*
metadata = {
    'name': '',
    'label': '',
    'description': '',
    'isaddendum': False,
    'datemodified': None,
    'modifiedbyuserid': None,
}
 */
export function updateFileMetadata$({type, id, subId, fileId, metadata }) {
  let url;
  let query = {};
  switch (type) {
    case PROJECT:
      if (!id) throw new APIError("No id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'files', fileId);
      break;
    case BID:
      if (!id) throw new APIError("No id specified");
      url = URI.joinPaths(API_BASE, 'bids', id, 'files', fileId);
      break;
    case RFI:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'project-rfis', subId, 'files', fileId);
      break;
    case SUBMITTAL:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'submittals', subId, 'files', fileId);
      break;
    case TASK:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'tasks', subId, 'files', fileId);
      break;
    case PUNCHLIST:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'punches', subId, 'files', fileId);
      break;
    case DAILYLOG:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'daily-logs', subId, 'files', fileId);
      break;
    case MEETINGMINUTES:
      if (!id) throw new APIError("No id specified");
      if (!subId) throw new APIError("No sub-id specified");
      url = URI.joinPaths(API_BASE, 'projects', id, 'meeting-minutes', subId, 'files', fileId);
      break;
    default:
      throw new APIError('not implemented');
  }
  url = url.query(URI.buildQuery(query));
  return ajaxAuthed({
      url: url.toString(), method: 'PUT', body: metadata,
      headers: { 'Content-Type': 'application/json'}
    }, type);
}




// WEBPACK FOOTER //
// ./src/services/files.js